// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification_card {
  width: 369.63px;
  border-radius: 17px;
  box-shadow: 4.4444441795px 4.4444441795px 34.0740737915px 0px rgba(0, 0, 0, 0.2588235294);
}
.notification_card .notification_title {
  font-family: Inter;
  font-size: 20px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.02em;
  text-align: left;
}
.notification_card .notification_mark_all {
  font-family: Karla;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: -0.04em;
  color: #45852E;
  cursor: pointer;
}
.notification_card .notification_parent .notification {
  border-bottom: 0.74px solid #E3E3E3;
}
.notification_card .notification_parent .notification .notification_heading {
  font-family: Inter;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.02em;
}
.notification_card .notification_parent .notification .notification_details {
  font-family: Karla;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.02em;
}
.notification_card .notification_parent .notification .notification_timing {
  font-family: Karla;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: -0.02em;
  color: rgba(0, 0, 0, 0.5019607843);
}
.notification_card .notification_parent .notification_viewall {
  font-family: Karla;
  font-size: 14px;
  font-weight: 400;
  line-height: 17px;
  letter-spacing: -0.04em;
  color: #45852E !important;
  cursor: pointer;
}

.Notification_footer,
.common-footer {
  display: flex;
  justify-content: end;
  align-items: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 77.04px;
  background-color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/components/NotificationComponent/Notification.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,mBAAA;EACA,yFAAA;AACJ;AAEI;EAEI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,gBAAA;AADR;AAII;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AAFR;AAQQ;EACI,mCAAA;AANZ;AAQY;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AANhB;AAWY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;AAThB;AAcY;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,kCAAA;AAZhB;AAmBQ;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;AAjBZ;;AAyBA;;EAEI,aAAA;EACA,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;AAtBJ","sourcesContent":[".notification_card {\n    width: 369.63px;\n    border-radius: 17px;\n    box-shadow: 4.444444179534912px 4.444444179534912px 34.074073791503906px 0px #00000042;\n\n\n    .notification_title {\n\n        font-family: Inter;\n        font-size: 20px;\n        font-weight: 600;\n        line-height: 32px;\n        letter-spacing: -0.02em;\n        text-align: left;\n    }\n\n    .notification_mark_all {\n        font-family: Karla;\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 17px;\n        letter-spacing: -0.04em;\n        color: #45852E;\n        cursor: pointer;\n\n\n    }\n\n    .notification_parent {\n        .notification {\n            border-bottom: 0.74px solid #E3E3E3;\n\n            .notification_heading {\n                font-family: Inter;\n                font-size: 14px;\n                line-height: 18px;\n                letter-spacing: -0.02em;\n\n\n            }\n\n            .notification_details {\n                font-family: Karla;\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 16px;\n                letter-spacing: -0.02em;\n\n\n            }\n\n            .notification_timing {\n                font-family: Karla;\n                font-size: 12px;\n                font-weight: 400;\n                line-height: 17px;\n                letter-spacing: -0.02em;\n                color: #00000080;\n\n            }\n\n\n        }\n\n        .notification_viewall {\n            font-family: Karla;\n            font-size: 14px;\n            font-weight: 400;\n            line-height: 17px;\n            letter-spacing: -0.04em;\n            color: #45852E !important;\n            cursor: pointer;\n\n        }\n\n\n    }\n}\n\n.Notification_footer,\n.common-footer {\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    position: fixed;\n    bottom: 0;\n    width: 100%;\n    height: 77.04px;\n    background-color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
